const STORAGE_KEY = 'defconai-last-environment'

/** Store the last-visited environment for redirect purposes. */
export function setLastModule(name: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, name)
  } catch {
    // Ignore storage errors (private browsing, quota)
  }
}

/** Get the last-visited environment, defaulting to empty when unset. */
export function getLastEnvironment(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? ''
  } catch {
    return ''
  }
}
